import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import {
  Language,
  TaxonomyMarketAbbreviaton,
} from '../../common/CountryMarketConfig';
import { RootState } from '../../shared/store';
import { Taxonomies } from '../../types/briefing';

export type TaxonomyState = Partial<
  Record<
    TaxonomyMarketAbbreviaton,
    Partial<
      Record<
        Language,
        {
          updatedAt: string;
          taxonomies?: Taxonomies;
          error?: string;
        }
      >
    >
  >
>;

const initialState: TaxonomyState = {};

export const state = createSlice({
  name: 'taxonomyState',
  initialState,
  reducers: {
    resetAll: () => initialState,
    setTaxonomies: (
      taxonomyState,
      {
        payload: { taxonomies, market, language },
      }: PayloadAction<{
        taxonomies: Taxonomies;
        market: TaxonomyMarketAbbreviaton;
        language: Language;
      }>,
    ) => {
      taxonomyState[market] = {
        ...taxonomyState[market],
        [language]: {
          taxonomies,
          updatedAt: new Date().toISOString(),
        },
      };
    },
    setTaxonomiesError: (
      taxonomyState,
      {
        payload: { error, market, language },
      }: PayloadAction<{
        error: string;
        market: TaxonomyMarketAbbreviaton;
        language: Language;
      }>,
    ) => {
      taxonomyState[market] = {
        ...taxonomyState[market],
        [language]: {
          error,
          updatedAt: new Date().toISOString(),
        },
      };
    },
  },
});

export const useTaxonomyState = (): [TaxonomyState, typeof state.actions] => [
  useSelector((rootState: RootState) => rootState.taxonomies),
  state.actions,
];

export const actions = state.actions;

export const reducers = state.reducer;
